export function bindCustomVh() {
  window.addEventListener('resize', setCustomVh);

  setCustomVh();
}

function setCustomVh() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  document.documentElement.style.setProperty('--vh100', `${vh * 100}px`);
}
